<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M4 5.5C4 4.67157 4.67157 4 5.5 4H7C7.82843 4 8.5 4.67157 8.5 5.5V7C8.5 7.82843 7.82843 8.5 7 8.5H5.5C4.67157 8.5 4 7.82843 4 7V5.5Z" 
    stroke="currentColor" stroke-width="1.49625" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 13C4 12.1716 4.67157 11.5 5.5 11.5H7C7.82843 11.5 8.5 12.1716 8.5 13V14.5C8.5 15.3284 7.82843 16 7 16H5.5C4.67157 16 4 15.3284 4 14.5V13Z" 
    stroke="currentColor" stroke-width="1.49625" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.5 5.5C11.5 4.67157 12.1716 4 13 4H14.5C15.3284 4 16 4.67157 16 5.5V7C16 7.82843 15.3284 8.5 14.5 8.5H13C12.1716 8.5 11.5 7.82843 11.5 7V5.5Z" 
    stroke="currentColor" stroke-width="1.49625" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M11.5 13.75C11.5 12.5073 12.5073 11.5 13.75 11.5C14.9927 11.5 16 12.5073 16 13.75C16 14.9927 14.9927 16 13.75 16C12.5073 16 11.5 14.9927 11.5 13.75Z" 
    stroke="currentColor" stroke-width="1.49625" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'ProductCategoryIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>